import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	messageText: {
		whiteSpace: "break-spaces"
	},
	absentMessageText: {
		fontStyle: "italic"
	}
})

export default useStyles
